export const BREAKPOINTS = {
	md: 768,
	lg: 992,
	xl: 1200,
};

export function breakpoint(bp: keyof typeof BREAKPOINTS) {
	return window.innerWidth >= BREAKPOINTS[bp];
}
